import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { TzadikimModel } from '../../../../models/tz.model';
import { TzadikimService } from '../../../../services/tz.service';
import { NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { RouterModule } from '@angular/router';

@Component({
    standalone:true,
    imports:[FormsModule,NgIf,NgForOf, MatTableModule,MatPaginatorModule,RouterModule],
    providers:[TzadikimService],
    selector: 'tzadikim-index',
    templateUrl: './tzadikim-index.component.html',
    styleUrls: ['./tzadikim-index.component.css']
})

export class TzadikimIndexComponent implements AfterViewInit,OnInit {
    filter: string;
    allTzadikims!: TzadikimModel[];
    tzadikims!: TzadikimModel[];
    displayedColumns: string[] = ['המכונה בפי כל', 'שם משפחה', 'שטאט', 'לע"נ', 'נולד', 'נפטר','actions'];
    dataSource = new MatTableDataSource<TzadikimModel>();
    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor(private tzadikimService: TzadikimService) { }


    ngOnInit(): void {
        this.tzadikimService.getTzadikim().subscribe(t => {
            this.tzadikims = this.allTzadikims = t;
            this.dataSource.data = this.tzadikims
        });
        this.onSearch()
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
      }
    onDelete(id: number) {

        if (confirm("Are you sure?")) {
            this.tzadikimService.delete(id).subscribe(t => {
                var i = this.tzadikims.findIndex(function (t) {
                    return t.id == id;
                });

                this.tzadikims.splice(i, 1);
            });
        }
    }
    onSearch() {
        var tzadikims = this.allTzadikims;

        if (this.filter) {
            tzadikims = tzadikims.filter(t => t.title.includes(this.filter)
                || t.subTitle.includes(this.filter));
        }

        this.dataSource.data = tzadikims;
    }
}
